<p-button label="Add New Row" icon="pi pi-plus" (click)="addRow()" severity="secondary" />

<p-table [value]="data" dataKey="id" editMode="row" [tableStyle]="{ 'min-width': '50rem' }">
  <ng-template #header>
    <tr>
      <th style="width: 5%">id</th>
      @for (key of displayedColumns; track key) {
        @if (key != 'id' && key != 'actions') {
          <th>
            {{ key }}
          </th>
        }
      }
      <th style="width: 12%"></th>
    </tr>
  </ng-template>
  <ng-template #body let-row let-editing="editing" let-ri="rowIndex">
    <tr [pEditableRow]="row">
      <td>
        <p-cellEditor>
          <ng-template #input>
            @if (url) {
              <a [routerLink]="[url, row.id]">{{ row.id }}</a>
            } @else {
              {{ row.id }}
            }
          </ng-template>
          <ng-template #output>
            @if (url) {
              <a [routerLink]="[url, row.id]">{{ row.id }}</a>
            } @else {
              {{ row.id }}
            }
          </ng-template>
        </p-cellEditor>
      </td>

      @for (key of displayedColumns; track key) {
        @if (key != 'id' && key != 'actions') {
          <td>
            <!-- View Mode -->
            @if (!row.isEditing) {
              @if (url) {
                <a [routerLink]="[url, row.id]">{{ row[key] }}</a>
              } @else {
                {{ row[key] }}
              }
            } @else {
              <input
                type="text"
                [(ngModel)]="row[key]"
                placeholder="Enter {{ key }}"
                class="edit-input"
              />
            }
          </td>
        }
      }

      @if (!disableEdit) {
        <td>
          @if (!row.isEditing) {
            <button
              pButton
              pRipple
              type="button"
              pInitEditableRow
              icon="pi pi-pencil"
              (click)="enableEditMode(row)"
              text
              rounded
              severity="secondary"
            ></button>
            <p-button
              icon="pi pi-times"
              [rounded]="true"
              [text]="true"
              severity="danger"
              (click)="deleteEdit(row)"
            />
          } @else {
            <button
              pButton
              pRipple
              type="button"
              pSaveEditableRow
              icon="pi pi-check"
              (click)="updateRow(row)"
              text
              rounded
              severity="secondary"
            ></button>
            <button
              pButton
              pRipple
              type="button"
              pCancelEditableRow
              icon="pi pi-times"
              (click)="cancelEdit(row)"
              text
              rounded
              severity="secondary"
            ></button>
          }
        </td>
      }
    </tr>
  </ng-template>
</p-table>
